/**
 * Norno, o Relojoeiro (boss final, AC-M4-04). 3 fases por HP: 100–66% (fase 1), 66–33% (fase 2),
 * <33% (fase 3). Na fase 3 o Norno fica IMUNE a dano — a vitória vem de EMPURRAR OS PONTEIROS
 * (objetivo espacial), não de DPS. Determinístico e puro (posições fixas). Opt-in via `config.norno`.
 */
import { desfechoFinal, type DesfechoFinal } from './story.ts';
import type { EnemySim, HeroSim } from './types.ts';

export const NORNO_HP = 2400;
export const NORNO_FASE3_HP_MIN = 0.3; // piso de HP na fase 3 (imunidade a DPS)
const PONTEIRO_RAIO = 90;

export interface Ponteiro {
  x: number;
  y: number;
  ativado: boolean;
}
export interface NornoState {
  fase: 1 | 2 | 3;
  ativados: number;
  meta: number;
  ponteiros: Ponteiro[];
  /** desfecho ao vencer (AC-M4-03): 'pendente' até a vitória; 'selado' (3 fragmentos) ou 'fugiu'. */
  desfecho: 'pendente' | DesfechoFinal;
}

/** fase pela fração de HP (100–66→1, 66–33→2, <33→3). */
export function nornoFase(hpFrac: number): 1 | 2 | 3 {
  return hpFrac > 0.66 ? 1 : hpFrac > 0.33 ? 2 : 3;
}

export function criarNorno(arenaW: number, arenaH: number): NornoState {
  const cx = arenaW / 2;
  const cy = arenaH / 2;
  return {
    fase: 1,
    ativados: 0,
    meta: 3,
    ponteiros: [
      { x: cx - 520, y: cy - 320, ativado: false },
      { x: cx + 520, y: cy - 320, ativado: false },
      { x: cx, y: cy + 400, ativado: false },
    ],
    desfecho: 'pendente',
  };
}

/** avança o Norno um tick. Fases só progridem; na fase 3 clampa o HP (imune) e conta ponteiros. */
export function atualizarNorno(
  n: NornoState,
  boss: EnemySim,
  heroes: readonly HeroSim[],
  fragmentos = 0,
): 'ativo' | 'vitoria' {
  const frac = boss.maxHp > 0 ? boss.hp / boss.maxHp : 0;
  const f = nornoFase(frac < 0 ? 0 : frac);
  if (f > n.fase) n.fase = f; // fases nunca retrocedem
  if (n.fase === 3) {
    boss.alive = true; // imune: DPS não mata na fase 3
    if (boss.hp < boss.maxHp * NORNO_FASE3_HP_MIN) boss.hp = boss.maxHp * NORNO_FASE3_HP_MIN;
    const vivos = heroes.filter((h) => h.alive && !h.down);
    for (const p of n.ponteiros) {
      if (p.ativado) continue;
      if (vivos.some((h) => (h.x - p.x) * (h.x - p.x) + (h.y - p.y) * (h.y - p.y) <= PONTEIRO_RAIO * PONTEIRO_RAIO)) {
        p.ativado = true;
        n.ativados += 1;
      }
    }
    if (n.ativados >= n.meta) {
      boss.alive = false; // ponteiros empurrados → Norno cai
      n.desfecho = desfechoFinal(fragmentos); // AC-M4-03: 3 fragmentos → selado; senão foge
      return 'vitoria';
    }
  }
  return 'ativo';
}
